import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * RouteTitle - sets the browser tab title for authenticated app routes.
 *
 * Mounted once inside the Router. Public marketing pages (/, /login, /register)
 * manage their own <title> + meta description via usePageMeta, so they are
 * intentionally absent here and left untouched when no pattern matches.
 *
 * Order matters: more specific patterns must come before broader ones.
 */
const ROUTE_TITLES = [
  [/^\/dashboard/, "Dashboard"],
  [/^\/clients\/[^/]+\/overview/, "Client Overview"],
  [/^\/clients/, "Clients"],
  [/^\/scans\/new/, "New Scan"],
  [/^\/scans\/[^/]+\/flagged/, "Flagged Content"],
  [/^\/scans\/[^/]+/, "Scan Details"],
  [/^\/scans/, "Scans"],
  [/^\/monitoring/, "Monitoring"],
  [/^\/reports/, "Reports"],
  [/^\/support/, "Support"],
  [/^\/repguard-install/, "Install RepGuard"],
  [/^\/global-admin/, "Global Admin"],
  [/^\/admin/, "Admin"],
  [/^\/onboarding/, "Get Started"],
];

export default function RouteTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const match = ROUTE_TITLES.find(([re]) => re.test(pathname));
    if (match) document.title = `${match[1]} · RepCheck`;
  }, [pathname]);
  return null;
}
